import "../css/Reviews.css";

const reviews = [
  {
    text: "A place where time slows down. I came for coffee and stayed for hours.",
    author: "Aarav Mehta",
    role: "Regular Visitor",
  },
  {
    text: "Warm light, calm music, and honestly the best cappuccino in the city.",
    author: "Sofia Laurent",
    role: "Coffee Lover",
  },
  {
    text: "Neo Café feels less like a café and more like a second home.",
    author: "Daniel Kim",
    role: "Remote Worker",
  },
  {
    text: "Everything here feels intentional — from the cups to the silence.",
    author: "Ananya Rao",
    role: "Designer",
  },
  {
    text: "I don’t rush here. And that’s the point.",
    author: "Lucas Moretti",
    role: "Writer",
  },
];

const Reviews = () => {
  return (
    <main className="reviews">

      {/* HERO */}
      <section className="reviews-hero">
        <h1>Reviews</h1>
        <p>Words shared by people who stayed a little longer</p>
      </section>

      {/* QUOTE BLOCK */}
      <section className="reviews-statement">
        <h2>
          Not just feedback.<br />
          These are moments remembered.
        </h2>
      </section>

      {/* REVIEWS GRID */}
      <section className="reviews-grid">
        {reviews.map((review, index) => (
          <div key={index} className="review-card">
            <p className="review-text">“{review.text}”</p>
            <div className="review-author">
              <span>{review.author}</span>
              <small>{review.role}</small>
            </div>
          </div>
        ))}
      </section>

      {/* FINAL NOTE */}
      <section className="reviews-final">
        <p>
          Every review is a reminder<br />
          that coffee is better when shared.
        </p>
      </section>

    </main>
  );
};

export default Reviews;
